module.exports = __webpack_public_path__ + "static/Banner-13-940105ed6dbeacc6087bcb6ae34e868d.png";